import Button from "../../../elements/Button/Button";
import {motion} from "framer-motion";
import styles from './ModalStatus.module.scss'
import {useDispatch, useSelector} from "react-redux";
import {closeModal} from "../../../../store/actions/modalActions";
import {fetchInvoice, markInvoiceAsPaid} from "../../../../store/actions/invoicesActions";

const ModalStatus = ({variants}) => {
    const dispatch = useDispatch();
    const invoice = useSelector((state) => state.invoices.currentInvoice);

    const handleMarkAsPaid = async () => {
        await dispatch(markInvoiceAsPaid(invoice));
        dispatch(closeModal());
        await dispatch(fetchInvoice(invoice.id));
    }

    return (
        <motion.div className={styles.container} variants={variants}>
            <h2>Confirm Status</h2>
            <p className={styles.modalText}>
                Are you sure you want to change status of invoice # {invoice.number}?
                This action cannot be undone.
            </p>
            <div className={styles.ctaGroup}>
                <Button type="button" className='tertiary' onClick={() => dispatch(closeModal())}>
                    Cancel
                </Button>
                <Button
                    type="button"
                    className='primary'
                    onClick={handleMarkAsPaid}
                >
                    Mark as Paid
                </Button>
            </div>
        </motion.div>
    );
};

export default ModalStatus;
